<template>
  <div :class="$style.wrapper">
    <div
      :class="$style.colorSwatch"
      :style="{ backgroundColor: tinycolor(mode.value).toHexString() }"
    />
    {{ tinycolor(mode.value).toHexString().toUpperCase() }}
  </div>
</template>

<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.colorSwatch {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  border: 1px solid #0000001a;
}
</style>

<script setup>
import tinycolor from 'tinycolor2';

defineProps({
  mode: {
    type: Object,
    required: true,
  },
});
</script>
